export default __webpack_public_path__ + "static/Deeper-dive-ehe-masterclass-video-thumbnail-c352c2fd646cc7b6c0ee37d45f9eaeb2.png";